// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file event/v1/billing_event.proto (package event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { PayRequestStatus } from "../../common/v1/common_pb";

/**
 * Event SubType which is in billing payload
 *
 * @generated from enum event.v1.BillingType
 */
export const BillingType = proto3.makeEnum(
  "event.v1.BillingType",
  [
    {no: 0, name: "BILLING_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "BILLING_TYPE_PAY", localName: "PAY"},
    {no: 2, name: "BILLING_TYPE_SETUP_CHECKOUT_INTENT", localName: "SETUP_CHECKOUT_INTENT"},
  ],
);

/**
 * Represents the actual body of a billing event message; a billing event occurs
 * when a merchant invokes a billable public API.
 * Most of the fields are defined at:
 * https://jiradc-cib-cluster02.prod.aws.jpmchase.net/browse/MSTHPS-754
 *
 * @generated from message event.v1.BillingEventPayload
 */
export const BillingEventPayload = proto3.makeMessageType(
  "event.v1.BillingEventPayload",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "core_td_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "transaction_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "intent_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "intent_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "services_rendered_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "billable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "merchant_locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "service_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "internal_service_code", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "timestamp", kind: "message", T: Timestamp },
    { no: 15, name: "response_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "pay_request_status", kind: "enum", T: proto3.getEnumType(PayRequestStatus) },
    { no: 17, name: "secondary_td_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "billing_type", kind: "enum", T: proto3.getEnumType(BillingType) },
  ],
);

